"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedearcare = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 42 52",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedearcare` : '') + (description ? ` desc-brandedearcare` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedearcare"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedearcare"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.98 11.02h-3v30h3v-30Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 7.07c0 2.36-1.8 4.6-3.33 6.07a3.08 3.08 0 0 1-4.24.03C1.86 11.7 0 9.44 0 7.07 0 2.96 2.56 0 5.56 0 8.56 0 11 2.95 11 7.07Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 44.9c0-2.37-1.8-4.6-3.33-6.08a3.07 3.07 0 0 0-4.24-.03C1.86 40.26 0 42.52 0 44.9c0 4.12 2.56 7.07 5.56 7.07 3 0 5.44-2.95 5.44-7.07Z",
    fill: "#FFC599"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.7 26.22c.06-.07.1-.14.14-.22.05-.1.07-.2.08-.32.1-2.34.4-16.98-8.3-20.18-.2.12-.44.19-.68.19h-5.97c-.25 0-.48-.07-.69-.19-8.71 3.2-8.4 17.84-8.3 20.18a.85.85 0 0 0 .22.54l.76.83c.3.32.3.84 0 1.15l-.75.82a.75.75 0 0 0-.14.23.7.7 0 0 0-.07.33v9.08c0 .22.08.42.21.58l.75.81c.3.32.3.84 0 1.15l-.75.82a.86.86 0 0 0-.21.57v6.16c0 1.8 1.34 3.25 2.98 3.25h17.94c1.65 0 2.98-1.45 2.98-3.25V42.6a.87.87 0 0 0-.21-.57l-.75-.82a.87.87 0 0 1 0-1.15l.75-.81a.86.86 0 0 0 .21-.58v-9.08a.73.73 0 0 0-.07-.33.68.68 0 0 0-.14-.23l-.75-.82a.87.87 0 0 1 0-1.15l.76-.83Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34.1 1.71C34.1.76 33.41 0 32.6 0h-6c-.83 0-1.5.76-1.5 1.71V4.3c0 .95.67 1.71 1.5 1.71h6c.82 0 1.5-.76 1.5-1.71V1.7Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.96 48.75V42.6a.87.87 0 0 0-.22-.58l-.75-.8a.87.87 0 0 1 0-1.16l.75-.82a.86.86 0 0 0 .22-.57v-9.08a.72.72 0 0 0-.08-.33.67.67 0 0 0-.14-.23l-.75-.82a.87.87 0 0 1 0-1.15l.76-.83a.64.64 0 0 0 .14-.22c.05-.1.07-.2.08-.32.05-1.2.16-5.71-.96-10.22a99.56 99.56 0 0 1-22.97 23.4c.04.14.1.27.18.37l.75.82c.3.32.3.83 0 1.15l-.75.81a.86.86 0 0 0-.22.58v6.16c0 1.78 1.32 3.22 2.95 3.24h18.06c1.63-.02 2.95-1.46 2.95-3.24Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.21 29.02a.75.75 0 0 0-.14.23h15.34V26H18.06c.03.08.08.16.14.22l.75.83a.9.9 0 0 1 0 1.15l-.74.82Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M41.7 42.01a.6.6 0 0 1 .15.24H18.07c.03-.09.1-.18.15-.24l.74-.8a.88.88 0 0 0 0-1.16l-.75-.83a.77.77 0 0 1-.14-.22h23.8a.77.77 0 0 1-.15.22l-.75.83a.88.88 0 0 0 0 1.15l.74.81Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m41.75 29.01-.74-.8a.88.88 0 0 1 0-1.16l.75-.83a.7.7 0 0 0 .14-.22h-9.21c-1 1.1-2.04 2.19-3.1 3.25h12.3a.75.75 0 0 0-.14-.24Z",
    fill: "#CC0058"
  }));
};
var _default = exports.default = brandedearcare;